import { call } from './apiHelpers';

export const dashboardService = {
  getSummary: (_, filters) => call('get', 'dashboard/', null, filters),
};
